<template>
  <div class="loading_screen" v-show="this.mainStore.isLoaded === false">
    <img src="/img/logo_blanco.png" class="img_title" alt="El capricho">
    <!--<svg v-show="this.mainStore.isLoaded === true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;align-self: center;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <rect x="21.5" y="34.5" width="7" height="31" fill="#bea58b">
    <animate attributeName="y" repeatCount="indefinite" dur="0.9345794392523364s" calcMode="spline" keyTimes="0;0.5;1" values="25.2;34.5;34.5" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.18691588785046728s"/>
    <animate attributeName="height" repeatCount="indefinite" dur="0.9345794392523364s" calcMode="spline" keyTimes="0;0.5;1" values="49.6;31;31" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.18691588785046728s"/>
    </rect>
    <rect x="46.5" y="34.5" width="7" height="31" fill="#bea58b">
    <animate attributeName="y" repeatCount="indefinite" dur="0.9345794392523364s" calcMode="spline" keyTimes="0;0.5;1" values="27.525;34.5;34.5" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.09345794392523364s"/>
    <animate attributeName="height" repeatCount="indefinite" dur="0.9345794392523364s" calcMode="spline" keyTimes="0;0.5;1" values="44.95;31;31" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.09345794392523364s"/>
    </rect>
    <rect x="71.5" y="34.5" width="7" height="31" fill="#bea58b">
    <animate attributeName="y" repeatCount="indefinite" dur="0.9345794392523364s" calcMode="spline" keyTimes="0;0.5;1" values="27.525;34.5;34.5" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"/>
    <animate attributeName="height" repeatCount="indefinite" dur="0.9345794392523364s" calcMode="spline" keyTimes="0;0.5;1" values="44.95;31;31" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"/>
    </rect>
    </svg>-->
    <img src="/img/buey_load.gif" class="img_loading" alt="">
    </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore';

export default {
  name: 'LoadingScreen',
  setup(){
    const mainStore = useMainStore()
    return { mainStore }
  },
  methods:{
    startExperience: function(){
        //document.getElementById('ambient_audio').play(); //save for later
        this.mainStore.isStarted = true;
    }
  }
}
</script>


<style scoped> 
    .loading_screen{
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: #2B282C;
        z-index: 9999;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .img_title{
      width:280px;
    }
    .img_loading{
      width: 120px;
    }
    .button_primary{
        outline: none;
        border: 2px solid #BEA58B;
        width: 90px;
        height: 40px;
        padding-top: 5px;/*Font correction*/ 
        color:#fff;
        background-color: transparent;
        font-family: 'cervo';
        font-size: 22px;
        align-self: center;
        /*position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);*/
    }
    .legal{
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
    }
    .legal>a{
      color:#BEA58B;
      font-family: 'garamond';
    }
</style>
